import { faCircleXmark, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useAuth } from '../Context/UserContext';
import { Link, useNavigate } from 'react-router-dom';
import './css/HomePage.css';
import Login from '../Assests/Login Illustration.png'
import buglogo from '../Assests/buglogo.png';
import bugtrack from '../Assests/Frame 495.png'
import { toast, ToastContainer } from 'react-toastify';
import './css/LoginPage.css'
import { Icon } from '@iconify/react';
import axios from 'axios';
import { useRef } from 'react';
import { url } from '../constants/url';

export const LoginPage = () => {


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [error, setError] = useState('');
    const [openMFA, setOpenMFA] = useState(null)
    const [otp, setOtp] = useState(["", "", "", "", "", ""])
    const [otpError, setOtpError] = useState(false)

    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [showResend, setShowResend] = useState(true);

    const inputRefs = useRef([]);

    const navigate = useNavigate();

    const { login, isUpdated, isAuthenticated, verifyOTP } = useAuth();

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };


    const loginError = () => {
        toast.error("Too many attempts. Account is temporarily blocked", {
            position: "top-center",
            autoClose: 5000,
            pauseOnHover: false,
        });
    };


    // Refer UserContext.js for frontend api code
    const handleLogin = async (e) => {
        // e.preventDefault();
        setLoading(true);

        if (email === '') {
            setLoading(false);
            setEmailError('Email required');
            return;

        }
        else if (!/\S+@\S+\.\S+/.test(email)) {
            setLoading(false);
            setEmailError("Invalid email address");
            return;
        }
        else if (!email.includes('@')) {
            setLoading(false);
            setEmailError('Invalid Email');
            return;
        } else if (password === '') {
            setLoading(false);
            setPasswordError('Password required');
            return;
        } else {
            try {
                const response = await login(email, password);

                if (response.status === 200) {
                    setEmailError('');
                    setPasswordError('');
                    setError('');

                    if (response.data.mfa === true || response.data.mfa === "true") {
                        setOpenMFA(true);
                        setShowResend(true)
                        startTimer()
                        return
                    } else {
                        if (/\b@isecurion\.com$/.test(email)) {
                            navigate('/isecurion_dash');
                            return
                        } else {
                            navigate('/client_dashboard');
                            return
                        }
                    }
                }
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        }
    };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        if (!otp.join('')) {
            setOtpError(true);
            return;
        } else {
            try {
                const response = await verifyOTP(email, otp)
                if (response.status === 200) {
                    setOtp('')

                    if (response.status === 200) {
                        if (/\b@isecurion\.com$/.test(email)) {
                            navigate('/isecurion_dash');
                            return
                        } else {
                            navigate('/client_dashboard');
                            return
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const startTimer = (duration = 60) => {
        setTimer(duration);
        setCanResend(false);

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }

    const handleChange = (element, index) => {
        const value = element.value.replace(/\D/g, ""); // allow only digits
        if (value.length > 1) return; // only one digit per box

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input automatically
        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }

    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        } else if (e.key === "Enter") {
            handleVerifyOTP(e);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
        if (!pasteData) return;

        const newOtp = pasteData.split("");
        for (let i = 0; i < 6; i++) {
            newOtp[i] = newOtp[i] || "";
        }

        setOtp(newOtp);
        setOtpError(false)

        // Focus last filled box
        const lastFilled = newOtp.findLastIndex((d) => d !== "");
        if (lastFilled !== -1 && inputRefs.current[lastFilled]) {
            inputRefs.current[lastFilled].focus();
        }

    };

    const resendOTP = async () => {
        if (!canResend) return;
        setShowResend(false);
        try {
            const response = await fetch(`${url}/resendotp`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email, password
                })
            })
            if (response.status === 200) {
                setCanResend(false)
                setShowResend(true);
                startTimer(60)
                toast.success("OTP sent successfully", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            } else {
                setCanResend(true);
                setShowResend(true);
            }
        } catch (error) {
            console.log(error)
            setShowResend(true);
        }
    }


    return (
        <div className='wrap_login_layout'>
            <div className="layout-box">
                <div className="white-half">
                    <div className="innerbox">
                        <div className="inner-box">
                            <img
                                src={Login}
                                alt="Login Illustration"
                                className="inner-image"
                            />
                            <p className="inner-text">Your Gateway to Cybersecurity Insights</p>
                            <p className="inner-description">
                                Login to access your vulnerability reports, manage risks, and track application security progress—all in one place.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="gray-half">
                    <div className="icon_center">
                        <img src={buglogo} alt="Vulnytics" className="bugtrack-image" />
                    </div>
                    {!openMFA ? (

                        <div className="gray-inner-box">
                            <h2 className="form-heading">Sign In</h2>
                            {/* <p style={{fontSize:"20px", textAlign:'center', marginTop:'130px'}}>Application is under maintenance</p> */}
                            <div className="input-group">
                                <Icon icon="weui:email-outlined" className="input-icon1" />
                                <input
                                    type="email"
                                    placeholder="Email address"
                                    className="form-input"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setEmailError('');
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleLogin(e);
                                        }
                                    }}
                                />
                                {emailError && <p>{emailError}</p>}
                            </div>
                            <div className="input-group">
                                <Icon icon="solar:lock-password-linear" className='input-icon2' />
                                <input
                                    type={passwordVisible ? 'text' : 'password'}
                                    placeholder="Password"
                                    className="form-input password-input"
                                    id="passwordInput"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        setPasswordError('');
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleLogin(e);
                                            e.target.blur();
                                        }
                                    }}
                                />
                                <FontAwesomeIcon
                                    icon={passwordVisible ? faEye : faEyeSlash}
                                    onClick={togglePasswordVisibility}
                                    className='eye_icon'
                                    style={{ MozAppearance: 'textfield' }}
                                />
                                {passwordError && <p>{passwordError}</p>}
                            </div>
                            <button className="signin-button" onClick={handleLogin}>
                                {loading ? (
                                    <span>Logging in...</span>
                                ) : (
                                    'Login'
                                )}
                            </button>
                            {error && <h6 className='errorfile'>{error}</h6>}

                            <Link to='/forgotpasswordpage' className="forgot-password">Forgot Password</Link>
                        </div>
                    ) : (
                        <div className="gray-inner-box">
                            <h2 className="form-heading">Multi-Factor Authentication</h2>
                            <p style={{ textAlign: 'center', marginBottom: '15px' }}>
                                Enter the OTP sent to your registered email
                            </p>

                            <div className="input-group">
                                <div className="otp-container">

                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            type="text"
                                            className={`otp-box ${otpError ? "otp-error" : ""}`}
                                            maxLength={1}
                                            value={digit}
                                            onChange={(e) => {
                                                handleChange(e.target, index)
                                                if (otpError) setOtpError(false);
                                            }}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            onPaste={handlePaste}
                                        />
                                    ))}
                                </div>
                                {showResend && (
                                    <p
                                        style={{
                                            marginTop: "10px",
                                            color: canResend ? "#0077b6" : "#999",
                                            cursor: canResend ? "pointer" : "not-allowed",
                                            pointerEvents: canResend ? "auto" : "none",
                                        }}
                                        onClick={resendOTP}
                                    >
                                        {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
                                    </p>
                                )}

                            </div>

                            <button className="signin-button" onClick={handleVerifyOTP}>
                                Verify OTP
                            </button>

                        </div>
                    )}
                </div>
            </div >
            <div className='loginpage_copyright'>
                <p>© 2026, ISECURION Technology and Consulting Pvt. Ltd, All Rights Reserved.</p>
            </div>
        </div >
    )
};
